const List = {
  parts: ["container", "item", "icon"],
  baseStyle: {
    icon: {
      listStyle: "none",
      color: "#000091",
    },
    container: {
      marginLeft: 2,
    },
  },
}

export { List }
